__turbopack_context__.v({
  "root": "ForumIdFormatter-module__KEWgYq__root",
});
